"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var ApiError =
/*#__PURE__*/
function () {
  function ApiError(httpRequest, exception) {
    (0, _classCallCheck2.default)(this, ApiError);
    this.httpRequest = httpRequest;
    this.exception = exception || null;
  }

  (0, _createClass2.default)(ApiError, [{
    key: "getMessage",
    value: function getMessage() {
      if (this.exception) {
        return this.exception.toString();
      }

      if (this.httpRequest && this.httpRequest.readyState === XMLHttpRequest.DONE) {
        return this.httpRequest.statusText;
      }

      return 'httpRequest did not complete';
    }
  }]);
  return ApiError;
}();

var _default = ApiError;
exports.default = _default;
module.exports = exports.default;